import { forwardRef } from 'react';

function Label({ children, className, ...props }) {
    return (
        <label className={`${className || ''} block space-y-1 font-medium text-gray-700`} {...props}>
            {children}
        </label>
    );
}

const Input = forwardRef(({ className, ...props }, ref) => {
    return props.type == 'checkbox' ? (
        <input ref={ref} className={`${className || ''} inline-block rounded border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50`} {...props} />
    ) : (
        <input ref={ref} className={`${className || ''} block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50`} {...props} />
    );
});

function TextArea({ className, ...props }) {
    return <textarea className={`${className || ''} block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50`} {...props} />;
}

function Select({ options, placeholder, className, noEmpty = false, ...props }) {
    return (
        <select className={`${className || ''} block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50`} {...props}>
            {!noEmpty && (
                <option className="opacity-50" value="">
                    {placeholder}
                </option>
            )}
            {options?.map(({ id, name }) => (
                <option value={id} key={id}>
                    {name}
                </option>
            ))}
        </select>
    );
}

function Field({ className, children }) {
    return <div className={`${className || ''} space-y-1`}>{children}</div>;
}

export { Field, Label, Input, Select, TextArea };
